export default __webpack_public_path__ + "static/media/tutorial_2.ac6270d7.png";